var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1225 10.0082L19.2521 6.2819C19.1591 6.19258 19.0485 6.12168 18.9267 6.0733C18.8048 6.02491 18.6741 6 18.542 6C18.41 6 18.2793 6.02491 18.1574 6.0733C18.0355 6.12168 17.9249 6.19258 17.832 6.2819C17.7382 6.3705 17.6638 6.4759 17.613 6.59204C17.5623 6.70817 17.5361 6.83273 17.5361 6.95854C17.5361 7.08435 17.5623 7.20892 17.613 7.32505C17.6638 7.44119 17.7382 7.54659 17.832 7.63519L21.3924 11.047L1.00011 11.047C0.734864 11.047 0.480481 11.1474 0.292925 11.3261C0.105368 11.5048 5.46633e-07 11.7472 5.24537e-07 12C5.0244e-07 12.2528 0.105368 12.4952 0.292925 12.6739C0.480481 12.8526 0.734864 12.953 1.00011 12.953L21.4524 12.953L17.832 16.4029C17.6547 16.5802 17.5557 16.8156 17.5557 17.0605C17.5557 17.3054 17.6547 17.5409 17.832 17.7181C17.9249 17.8074 18.0355 17.8783 18.1574 17.9267C18.2793 17.9751 18.41 18 18.542 18C18.6741 18 18.8048 17.9751 18.9267 17.9267C19.0485 17.8783 19.1591 17.8074 19.2521 17.7181L23.1225 14.049C23.6844 13.5129 24 12.7862 24 12.0286C24 11.2709 23.6844 10.5443 23.1225 10.0082Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.7f3b6723679d15ce4b21c96a35d5a2b1.svg";
export { ForwardRef as ReactComponent };